module.exports = __webpack_public_path__ + "90200011beb81aae3cc26a5199673f91.ttf";